import React from 'react';
import style from './style.scss'; //NOSONAR

const Footer = () => {
    return (
        <footer className="cart-footer">
            <div className="cart-footer-container">
                <span className="cart-footer-span-copyright">© 2019 Jumbo | Copyright © Cencosud</span>
            </div>
        </footer>
    )
}

export default Footer;
